import { Flex, List, styled } from '@shared/components';

import { BackToPortalMenuItem, LogoutMenuItem, UserMenuItem } from '../MenuItem/ComposedMenuItem';

import SideBarToggleButton from './SideBarToggleButton';

const BottomMenu = styled(Flex)(({ theme }) => ({
  position: 'sticky',
  bottom: 0,
  flexDirection: 'column',
  marginTop: 'auto',
  borderTop: '1px solid',
  borderColor: theme.palette.grey[300],
  backgroundColor: 'white',
  width: '100%',
}));

interface SideBarStickyMenuProps {
  minified?: boolean;
  hideToggleButton?: boolean;
}

function SideBarStickyMenu(props: Readonly<SideBarStickyMenuProps>) {
  const { minified: shouldMinified, hideToggleButton: shouldHideToggleButton } = props;
  // const { external } = useConfig();
  // const supportURL = external?.supportURL;
  return (
    <BottomMenu>
      <List>
        <UserMenuItem minified={shouldMinified} />
        <BackToPortalMenuItem minified={shouldMinified} />
        {/* {supportURL ? (
          <MenuItem
            label='ศูนย์ช่วยเหลือ'
            icon={<HelpOutlineRounded />}
            onClick={() => window.open(supportURL)}
            minified={minified}
          />
        ) : null} */}
        <LogoutMenuItem minified={shouldMinified} />
      </List>
      {!shouldHideToggleButton ? <SideBarToggleButton /> : null}
    </BottomMenu>
  );
}

export default SideBarStickyMenu;
